import React, { useEffect, useRef, useState } from "react";

import { User } from "chq";

import { makeGet } from "@culturehq/client";
import { Loader, Panel, Table, Warning } from "@culturehq/components";

import { Trans } from "app/utils";
import ErrorMessage from "components/common/ErrorMessage";
import UserWithoutOrganizationRow from "./settings/user-without-organizations/UserWithoutOrganizationRow";

type StateProps = {
  loading: boolean;
  users: User[];
  error?: string;
}

const UsersWithoutOrganization = () => {
  const isMounted = useRef<boolean>();
  const [{ loading, users, error }, setState] = useState<StateProps>({
    loading: false,
    users: [],
    error: undefined
  });

  const handleState = (
    newProps: Partial<StateProps>
  ) => setState(prev => ({ ...prev, ...newProps }));

  const handleFetch = () => {
    makeGet("/organization_users")
      .then(({
        users
      }: any) => isMounted.current && handleState({ users, loading: false }));
  };

  useEffect(() => {
    isMounted.current = true;
    handleState({ loading: true });
    handleFetch();

    return () => {
      isMounted.current = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel limitWidth>
      <Panel.Heading primary>Users without Organization</Panel.Heading>
      <Panel.Body className="UserWithoutOrganizations">
        {error && <ErrorMessage error={error} />}
        <Loader loading={loading}>
          <Table className="no-scrollbar">
            <thead>
              <tr>
                <th><Trans>Name</Trans></th>
                <th><Trans>Email</Trans></th>
                <th className="actions"><Trans>Available Organizations</Trans></th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <UserWithoutOrganizationRow
                  key={user.id}
                  onFetch={handleFetch}
                  user={user}
                />
              ))}
            </tbody>
          </Table>

          {!users.length && (
            <Warning><Trans>No results to show.</Trans></Warning>
          )}
        </Loader>
      </Panel.Body>
    </Panel>
  );
};

export default UsersWithoutOrganization;
